import { toast, Zoom } from "react-toastify";

const useToast = () => {
  const showError = (message: string) => {
    toast.error(message ?? "اروری به وجود آمده است", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
      bodyClassName: "text-sm",
      transition: Zoom,
    });
  };

  const showSuccess = (message: string) => {
    toast.success(message ?? "عملیات موفقیت آمیز بود", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
      bodyClassName: "text-sm",
      transition: Zoom,
    });
  };

  return { showError, showSuccess };
};

export default useToast;
